export default "__VITE_ASSET__7eRXILpf__"